import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { ElectricityLandingPage, ElectricityLandingPageProps } from "./ElectricityLandingPage";

export const EMPTY_PAGE_CONTENT: ElectricityLandingPageProps = {
  pageTitle: "",
};

export const CANONICAL_LINK = "/personal/electricity";

export const ElectricityLandingPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<ElectricityLandingPageProps>("electricity_landing_page", EMPTY_PAGE_CONTENT);
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <ElectricityLandingPage {...routeProps} {...content} />;
};
